<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Fechar Espelho de Ponto</div>
      </div>
      <div class="card-body">
        <div class="row" v-if="loaded">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-hover">
              <tr>
                <td>
                  <span v-if="showField('show_company_name')">
                    <span class="bold">Razão Social:</span>
                    {{ data.user.company.company_name }}
                  </span>
                </td>
                <td colspan="2">
                  <span v-if="showField('show_cnpj')">
                    <span class="bold">CNPJ:</span>
                    {{ data.user.company.cnpj }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span v-if="showField('show_employee_name')">
                    <span class="bold">Nome:</span>
                    {{ data.user.name }}
                  </span>
                </td>
                <td>
                  <span v-if="showField('show_admission_date')">
                    <span class="bold">Data de Admissão:</span>
                    {{ data.user.admission_date_f }}
                  </span>
                </td>
                <td>
                  <span v-if="showField('show_ctps')">
                    <span class="bold">CTPS:</span>
                    {{ displayOrNA(data.user.ctps) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span v-if="showField('show_cpf')">
                    <span class="bold">CPF:</span>
                    {{ displayOrNA(data.user.cpf) }}
                  </span>
                </td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td>
                  <span v-if="showField('show_pis_pasep')">
                    <span class="bold">PIS/PASEP:</span>
                    {{ displayOrNA(data.user.pis_pasep) }}
                  </span>
                </td>
                <td>
                  <span v-if="showField('show_role')">
                    <span class="bold">Função:</span>
                    {{ data.user && data.user.role ? data.user.role.title : 'N/A' }}
                  </span>
                </td>
                <td>
                  <span v-if="showField('show_department')">
                    <span class="bold">Departamento:</span>
                    {{ data.user && data.user.department ? data.user.department.title : 'N/A' }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span v-if="showField('show_period')">
                    <span class="bold">Período:</span>
                    {{ data.start_period }} até {{ data.end_period }}
                  </span>
                </td>
                <td>
                  <span v-if="showField('show_holidays')">
                    <span class="bold">Feriados no Período:</span>
                    {{ data.holidays }} dia(s).
                  </span>
                </td>
                <td>
                  <span v-if="showField('show_business_days')">
                    <span class="bold">Dias Úteis no Período:</span>
                    {{ data.usefull_days }} {{ data.usefull_days > 1 ? 'dias' : 'dia' }}.
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span v-if="showField('show_work_journey')">
                    <span class="bold">Jornada de Trabalho:</span>
                    {{ data.journey }} | {{ data.hours_journey }} horas.
                  </span>
                </td>
                <td>
                  <span v-if="showField('show_total_worked')">
                    <span class="bold">Total Trabalhado no Período:</span>
                    {{ periodTotalWorkedFormatted }} horas.
                  </span>
                </td>
                <td>
                  <span v-if="showField('show_total_to_work')">
                    <span class="bold">Total à Trabalhar no Período:</span>
                    {{ data.total_working }} horas.
                  </span>
                </td>
              </tr>
                <tr>
                  <td>
                    <span v-if="showField('show_hours_bank')">
                      <span class="bold">Banco de horas no período:</span>
                      {{ data.partial_bank_of_hours }} horas.
                    </span>
                  </td>
                  <td>
                    <span v-if="showField('show_total_interval')">
                      <span class="bold">Total de intervalo no período:</span>
                      {{ data.total_interval }}
                    </span>
                  </td>
                  <td>
                    <span v-if="showField('show_unauthorized_overtime')">
                      <span class="bold">Hora extra não autorizada (N.A.) no período:</span>
                      {{ periodUnauthorizedFormatted }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>

          </div>
        </div>

        <div class="row" v-if="loaded">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-hover table-sm" style="font-size: 14px;">
                <thead>
                  <tr>
                    <th style="white-space: nowrap;">TURNO</th>
                    <th class="status-col">STATUS</th>
                    <th
                      v-for="(col, ci) in punchColumns"
                      :key="'h-' + ci"
                      :class="{ 'interval-col': col.type === 'interval' }"
                      style="white-space: nowrap;"
                    >{{ col.label }}</th>
                    <th style="white-space: nowrap;">RESULTADO</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(check, index) in data.checks" :key="index">
                    <td style="white-space: nowrap;">
                      <strong>{{ formatDate(index) }}</strong>
                    </td>
                    <td class="status-col">
                      <div v-if="!isVacationDay(check)" class="status-badges">
                        <div v-if="isNormalSchedule(check)" class="status-item">
                          <span class="status-dot status-dot--normal"></span> Normal
                        </div>
                        <div v-if="isOvertimeSchedule(check)" class="status-item">
                          <span class="status-dot status-dot--overtime"></span> Hora Extra
                        </div>
                        <div v-if="isSwappedSchedule(check)" class="status-item status-item--clickable" @click="openScheduleSwapModal(check)">
                          <span class="status-dot status-dot--swapped"></span> Trocado
                        </div>
                        <div v-if="isDutySchedule(check)" class="status-item">
                          <span class="status-dot status-dot--duty"></span> Plantão
                        </div>
                      </div>
                    </td>

                    <template v-for="(col, ci) in punchColumns">
                      <!-- Intervalo (do backend) -->
                      <td v-if="col.type === 'interval'" :key="'i-' + index + '-' + ci" class="interval-col" style="white-space: nowrap;">
                        <strong>{{ isVacationDay(check) ? 'FÉRIAS' : (data.intervals && data.intervals[index] ? data.intervals[index][col.key] : '') }}</strong>
                      </td>

                      <!-- Batida -->
                      <td v-else :key="'p-' + index + '-' + ci" :class="getCheckClass(check[col.idx])" style="white-space: nowrap;">
                        <div v-if="isVacationEntry(check[col.idx])">
                          {{ getVacationLabel(check[col.idx]) }}
                        </div>
                        <div v-else-if="check[col.idx] && check[col.idx].created_at">
                          {{ formatDateTime(check[col.idx].created_at) }}
                          <br>
                          <small style="font-size: 12px;">{{ getCheckLegend(check[col.idx]) }}</small>
                          <div v-if="consideredHour(check[col.idx])" style="font-size: 12px; color: #6e7581;">
                            Previsto: {{ consideredHour(check[col.idx]) }}
                          </div>
                        </div>
                      </td>
                    </template>              

                    <!-- Resultado -->
                    <td>
                      <strong v-if="isVacationDay(check)">ABONADA</strong>
                      <div v-else class="result-cell">
                        <div class="result-row">
                          <span class="result-label">Horas Trabalhadas</span>
                          <span class="result-value">{{ getDayWorkedFormatted(check) }}</span>
                        </div>
                        <div class="result-row">
                          <span class="result-label">Horas Previstas</span>
                          <span class="result-value">{{ getDayExpectedFormatted(check) }}</span>
                        </div>
                        <div class="result-row">
                          <span class="result-label">Hora extra não autorizada (N.A.)</span>
                          <span class="result-value">{{ getUnauthorizedOvertimeFormatted(check) }}</span>
                        </div>
                        <div class="result-row">
                          <span class="result-label">Saldo</span>
                          <span class="result-value">{{ getDaySaldoFormatted(check) }}</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-md-12" v-if="collaboratorJustifications.length">
            <div class="card mt-2 mb-3">
              <div class="card-header py-2">
                <strong><i class="fas fa-comment-dots mr-1"></i> Solicitações de marcação</strong>
              </div>
              <div class="card-body p-0">
                <table class="table table-sm table-striped mb-0">
                  <thead>
                    <tr>
                      <th>Data da solicitação</th>
                      <th>Horário solicitado para marcação</th>
                      <th>Justificativa</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(j, i) in collaboratorJustifications" :key="i">
                      <td>{{ j.requestedAt ? formatDateTime(j.requestedAt) : '—' }}</td>
                      <td>{{ j.punchAt ? formatDateTime(j.punchAt) : '—' }}</td>
                      <td class="justification-text">"{{ j.text }}"</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="mb-4" v-if="!search.closed && !data.mirror_id">
              <button
                  class="btn btn-info w-100"
                  @click="closeMirror"
              >
                Fechar Espelho de Ponto
              </button>
            </div>

            <a
              class="btn btn-block btn-info"
              v-if="search.closed || search.mirror_id || data.mirror_id"
              href="#"
              @click.prevent="openMirror(search.mirror_id || data.mirror_id)"
              rel="noopener noreferrer"
            >
              Baixar Espelho de Ponto
            </a>
          </div>
          <div class="modal fade" id="openScheduleSwapModal" tabindex="-1" role="dialog" aria-labelledby="openScheduleSwapModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content swap-modal-content">
                <div class="modal-header swap-modal-header">
                  <div class="swap-modal-title-wrap">
                    <span class="swap-modal-icon">
                      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3"><path d="M17 2l4 4-4 4"/><path d="M21 6H3"/><path d="M7 22l-4-4 4-4"/><path d="M3 18h18"/></svg>
                    </span>
                    <h5 class="modal-title" id="openScheduleSwapModalLabel">Informações da Escala Trocada</h5>
                  </div>
                  <button type="button" class="close swap-modal-close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body swap-modal-body">
                  <div class="swap-field swap-field-full">
                    <div class="swap-field-label">Usuário Oficial da Escala</div>
                    <div class="swap-field-value">{{ displayOrNA(modalWorkSchedule.official_user_name) }}</div>
                  </div>
                  <div class="swap-field">
                    <div class="swap-field-label">Escala Anterior</div>
                    <div class="swap-field-value">{{ formatDateTime(modalWorkSchedule.original_shift_start, modalWorkSchedule.original_shift_end) }}</div>
                  </div>
                  <div class="swap-field">
                    <div class="swap-field-label">Aprovação da Troca</div>
                    <div class="swap-field-value swap-field-accent">{{ modalWorkSchedule.approved_at ? formatDateTime(modalWorkSchedule.approved_at) : 'N/A' }}</div>
                  </div>
                  <div class="swap-field swap-field-full">
                    <div class="swap-field-label">Justificativa</div>
                    <div class="swap-field-value swap-field-muted">{{ modalWorkSchedule.approver_justification || 'Nenhuma justificativa informada' }}</div>
                  </div>
                </div>
                <div class="modal-footer swap-modal-footer">
                  <button type="button" class="btn swap-btn-close" data-dismiss="modal">Fechar</button>
                </div>
              </div>
            </div>
          </div>     
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        data: [],
        loaded: false,
        modalWorkSchedule: [],        
        modalLoading: true,
        search: {
          year: parseInt(moment().year(), 10),
          month: parseInt(moment().month(), 10) + 1,
        }
      };
    },
    methods: {
    downloadMirror(id) {
      const base = this.$store.state.url || '';
      const normalized = base.endsWith('/') ? base : base + '/';
      return (
        normalized +
        "export/point_mirror/" +
        id +
        "/Innov@AR3PointMirror2120INnv"
      );
    },
    openMirror(id) {
      const url = this.downloadMirror(id);
      const w = window.open('about:blank', '_blank');
      if (w) {
        try {
          w.opener = null;
          w.location.href = url;
        } catch (e) {
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatTime(datetime) {
      if (!datetime) return '';
      return moment(datetime).format("HH:mm:ss");
    },
    formatDateTime(datetime) {
      if (!datetime) return '';
      return moment(datetime).format("DD/MM/YYYY HH:mm:ss");
    },
    formatShiftRange(start, end) {
      if (!start && !end) return 'N/A';
      const s = start ? moment(start, ['HH:mm:ss', 'HH:mm']).format('HH:mm') : '?';
      const e = end ? moment(end, ['HH:mm:ss', 'HH:mm']).format('HH:mm') : '?';
      return `${s} às ${e}`;
    },
    consideredHour(check) {
      if (!check || typeof check !== 'object') return null;
      const raw = check.time_to_consider || check.time_to_consider_f;
      if (!raw) return null;
      const m = moment(raw, ['YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm:ss', moment.ISO_8601]);
      return m.isValid() ? m.format('HH:mm') : null;
    },
    displayOrNA(value) {
      if (value === null || value === undefined) return 'N/A';
      if (typeof value === 'string' && (value.trim() === '' || value.trim().toLowerCase() === 'null')) return 'N/A';
      return value;
    },
    showField(field) {
      return !this.data.display_config || this.data.display_config[field] !== false;
    },
    isVacationEntry(check) {
      if (!check) return false;
      return Number(check.vacation || 0) > 0;
    },
    getVacationLabel(check) {
      if (!check) return '';
      return check.vacation_label || 'FÉRIAS';
    },
    isVacationDay(dayRow) {
      if (!dayRow) return false;
      return Object.keys(dayRow).some(
        (k) => /^\d+$/.test(k) && this.isVacationEntry(dayRow[k])
      );
    },
    getTotalInterval() {
                    if (!this.data.intervals) return '00:00:00';
                    let totalMs = 0;
                    Object.values(this.data.intervals).forEach(day => {
                      if (day && day.interval) {
                        const parts = day.interval.split(':');
                        if (parts.length === 3) {
                          const h = parseInt(parts[0], 10) || 0;
                          const m = parseInt(parts[1], 10) || 0;
                          const s = parseInt(parts[2], 10) || 0;
                          totalMs += ((h * 3600) + (m * 60) + s) * 1000;
                        }
                      }
                    });
                    const totalSeconds = Math.floor(totalMs / 1000);
                    const hours = Math.floor(totalSeconds / 3600);
                    const minutes = Math.floor((totalSeconds % 3600) / 60);
                    const seconds = totalSeconds % 60;
                    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
                  },
    getCheckClass(check) {
      if (!check) return '';
      if (Number(check.vacation || 0) > 0) return 'text-warning';
      if (check.manual) return 'text-purple';
      if (check.check_request_id || check.solicitation === 'true') return 'text-info';
      if (check.remote) return 'text-success';
      return '';
    },
    getCheckLegend(check) {
      if (!check) return '';
      if (Number(check.vacation || 0) > 0) return '(férias)';
      if (check.manual) return '(manual)';
      if (check.check_request_id || check.solicitation === 'true') return '(solicitada)';
      if (check.remote) return '(remota)';
      return '';
    },
    getDayMeta(check) {
      if (!check || !check.__meta) return {};
      return check.__meta;
    },
    getDayWorkedFormatted(check) {
      const meta = this.getDayMeta(check);
      return meta.total_worked_formatted || meta.total_formatted || check?.[6] || '00:00:00';
    },
    getDayExpectedFormatted(check) {
      const meta = this.getDayMeta(check);
      return meta.expected_formatted || '00:00:00';
    },
    getUnauthorizedOvertimeFormatted(check) {
      const meta = this.getDayMeta(check);
      if (meta.unauthorized_overtime_formatted) {
        return meta.unauthorized_overtime_formatted;
      }

      return '00:00:00';
    },
    getDaySaldoFormatted(check) {
      const meta = this.getDayMeta(check);
      return meta.diff_formatted || meta.diff_formatted_raw || '00:00:00';
    },
    isOvertimeSchedule(check) {
      const meta = this.getDayMeta(check);
      return !!meta.is_overtime_schedule;
    },
    isSwappedSchedule(check) {
      const meta = this.getDayMeta(check);
      return !!meta.is_swapped_schedule;
    },
    isDutySchedule(check) {
      const meta = this.getDayMeta(check);
      return !!meta.is_duty_schedule;
    },
    isNormalSchedule(check) {
      const meta = this.getDayMeta(check);
      return !meta.is_swapped_schedule && !meta.is_overtime_schedule && !meta.is_duty_schedule;
    },
    openScheduleSwapModal(show) {
      this.modalWorkSchedule = (show.__meta && show.__meta.swap_info) || {};
      this.modalLoading = false;
      
      $('#openScheduleSwapModal').modal('show');
      
      this.$nextTick(() => {
        $('#openScheduleSwapModal').on('hidden.bs.modal', () => {
          this.modalWorkSchedule = {};
          this.modalLoading = true;
        });
      });

    },
    formatDurationFromMs(msValue) {
      const totalSeconds = Math.max(0, Math.floor(Number(msValue || 0) / 1000));
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
    getEntity() {
      const self = this;
      const api = this.$store.state.api + "point-mirror";

      axios
        .post(api, self.search)
        .then((response) => {
          self.data = response.data;
          if (self.data.expected_hours === undefined || self.data.expected_hours === null) {
            if (self.data.worktime_monthly_hours) {
              self.data.expected_hours = parseInt(self.data.worktime_monthly_hours, 10);
            } else if (self.data.total_working_mili) {
              try {
                self.data.expected_hours = Math.round(self.data.total_working_mili / (1000 * 60 * 60));
              } catch (e) {
                // ignore
              }
            }
          }
          self.loaded = true;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    closeMirror() {
      const self = this;
      const api = this.$store.state.api + "point-mirror/close";

      self.data.month = self.search.month;
      self.data.year = self.search.year;
      axios
        .post(api, self.data)
        .then((response) => {
          self.data = response.data;
          self.loaded = true;
          self.$message(
            "Sucesso",
            "Espelho de ponto do período fechado com sucesso",
            "success"
          );
          self.$router.push(
            "/point-mirror/" + self.search.month + "/" + self.search.year
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  computed: {
    collaboratorJustifications() {
      const checks = this.data && this.data.checks ? this.data.checks : {};
      const list = [];
      Object.keys(checks).forEach((date) => {
        const day = checks[date] || {};
        Object.keys(day).forEach((k) => {
          if (!/^\d+$/.test(k)) return;
          const punch = day[k];
          const text = punch && punch.check_request_justification;
          if (text && String(text).trim() !== "") {
            list.push({
              requestedAt: (punch && punch.check_request_created_at) || null,
              punchAt: (punch && punch.created_at) || null,
              text: String(text).trim(),
            });
          }
        });
      });
      return list;
    },
    periodTotalWorkedFormatted() {
      if (!this.data || !this.data.checks) {
        return this.data && this.data.total_worked ? this.data.total_worked : '00:00:00';
      }

      const rows = Array.isArray(this.data.checks)
        ? this.data.checks
        : Object.values(this.data.checks || {});

      let totalMs = 0;
      rows.forEach((row) => {
        const meta = row && row.__meta ? row.__meta : null;
        if (!meta) return;
        const ms = Number(meta.total_worked_ms ?? meta.total_ms ?? 0);
        if (!Number.isNaN(ms) && ms > 0) {
          totalMs += ms;
        }
      });

      if (totalMs <= 0) {
        return this.data && this.data.total_worked ? this.data.total_worked : '00:00:00';
      }

      return this.formatDurationFromMs(totalMs);
    },
    periodUnauthorizedFormatted() {
      if (!this.data || !this.data.checks) return '00:00:00';

      const rows = Array.isArray(this.data.checks)
        ? this.data.checks
        : Object.values(this.data.checks || {});

      let totalMs = 0;
      rows.forEach((row) => {
        const meta = row && row.__meta ? row.__meta : null;
        if (!meta) return;
        const ms = Number(meta.unauthorized_overtime_ms ?? 0);
        if (!Number.isNaN(ms) && ms > 0) {
          totalMs += ms;
        }
      });

      return this.formatDurationFromMs(totalMs);
    },
    maxPunches() {
      const checks = this.data && this.data.checks ? this.data.checks : {};
      const rows = Array.isArray(checks) ? checks : Object.values(checks || {});
      let max = 2;
      rows.forEach((row) => {
        if (!row) return;
        Object.keys(row).forEach((k) => {
          if (/^\d+$/.test(k) && row[k] !== null && row[k] !== undefined) {
            max = Math.max(max, parseInt(k, 10) + 1);
          }
        });
      });
      return max;
    },
    numPairs() {
      return Math.ceil(this.maxPunches / 2);
    },
    punchColumns() {
      const cols = [];
      for (let p = 0; p < this.numPairs; p += 1) {
        cols.push({ type: 'punch', idx: p * 2, label: 'BATIDA ' + (p * 2 + 1) });
        cols.push({ type: 'punch', idx: p * 2 + 1, label: 'BATIDA ' + (p * 2 + 2) });
        if (p < this.numPairs - 1) {
          cols.push({ type: 'interval', key: 'interval_' + (p + 1), label: 'INT. ' + (p + 1) });
        }
      }
      return cols;
    }
  },
  mounted() {
    const self = this;

    setTimeout(function () {
      const query = self.$route.query;
      if (query.user_id && query.month && query.year) {
        self.search = {
          user_id: parseInt(query.user_id),
          month: parseInt(query.month),
          year: parseInt(query.year),
          closed: query.closed === 'true' || query.closed === '1',
          mirror_id: query.mirror_id ? parseInt(query.mirror_id) : null
        };
      } else {
        self.search = self.$store.state.closeMirror;
      }
      self.getEntity();
    }, 1000);
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
.text-purple {
  color: #6c3fb5;
}

.result-cell {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 260px;
}

.result-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  border-bottom: 1px dashed #d9dee3;
  padding-bottom: 0.1rem;
}

.result-row:last-child {
  border-bottom: none;
}

.result-label {
  font-weight: 600;
  color: #3d4551;
}

.result-value {
  font-variant-numeric: tabular-nums;
  color: #20242a;
}

.interval-col {
  background: #f8f8f8;
}

.dark-layout .interval-col {
  background: #3b4253;
}

.dark-layout .result-label {
  color: #d5dae0;
}

.dark-layout .result-value {
  color: #f2f4f6;
}

.status-col {
  white-space: nowrap;
  max-width: 100px;
}

.status-badges {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 12px;
  font-weight: 600;
  color: #3d4551;
  white-space: nowrap;
}

.dark-layout .status-item {
  color: #d5dae0;
}

.status-item--clickable {
  cursor: pointer;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-dot--normal {
  background: #2f80ed;
}

.status-dot--overtime {
  background: #27ae60;
}

.status-dot--swapped {
  background: #f2994a;
}

.status-dot--duty {
  background: #9b51e0;
}

.justification-item {
  padding: 0.4rem 0.2rem;
  border-bottom: 1px solid #eef0f2;
}
.justification-item:last-child {
  border-bottom: none;
}
.justification-head {
  font-size: 0.9rem;
}
.justification-text {
  color: #555;
  font-style: italic;
  margin-top: 0.15rem;
}

/* Modal "Informações da Escala Trocada" — versão refinada */
.swap-modal-content {
  border: none;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.swap-modal-header {
  align-items: center;
  padding: 22px 26px;
  background: linear-gradient(180deg, #eef3fd, #ffffff);
  border-bottom: 1px solid #dbe6fa;
}

.dark-layout .swap-modal-header {
  background: #283046;
  border-bottom-color: rgba(90, 140, 255, 0.2);
}

.swap-modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.swap-modal-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #1b4dd8;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dark-layout .swap-modal-icon {
  background: rgba(90, 140, 255, 0.3);
  color: #f2f4f6;
}

.swap-modal-header .modal-title {
  font-weight: 600;
  font-size: 16px;
  margin: 0;
}

.swap-modal-close {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  margin: 0;
  padding: 0;
}

.dark-layout .swap-modal-close {
  background: rgba(255, 255, 255, 0.08);
  color: #f2f4f6;
}

.swap-modal-body {
  padding: 24px 26px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.swap-field {
  padding: 14px 16px;
  background: #f5f8fd;
  border: 1px solid #dbe6fa;
  border-radius: 10px;
}

.dark-layout .swap-field {
  background: #2f303f;
  border-color: rgba(90, 140, 255, 0.15);
}

.swap-field-full {
  grid-column: 1 / -1;
}

.swap-field-label {
  font-weight: 600;
  font-size: 10.5px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8a8fa0;
  margin-bottom: 5px;
}

.dark-layout .swap-field-label {
  color: #a9adba;
}

.swap-field-value {
  font-weight: 600;
  font-size: 14px;
  color: #20242a;
}

.dark-layout .swap-field-value {
  color: #f2f4f6;
}

.swap-field-accent {
  color: #1b4dd8;
}

.dark-layout .swap-field-accent {
  color: #a9c2ff;
}

.swap-field-muted {
  font-weight: 400;
  font-size: 13.5px;
  color: #8a8fa0;
}

.swap-modal-footer {
  padding: 16px 26px 22px;
  border-top: none;
  justify-content: flex-end;
}

.swap-btn-close {
  padding: 10px 22px;
  background: #04187a;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  box-shadow: 0 2px 10px rgba(63, 65, 181, 0.3);
}

.swap-btn-close:hover {
  background: #273580;
  color: #fff;
}
</style>
